export default __webpack_public_path__ + "static/media/gallery-3.b4d3fc56.jpg";